/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MeetingSectionTextTopic', 'model/MeetingSectionTopicAttachment', 'model/MeetingSectionTopicCommentPaginationSlice', 'model/MeetingSectionTopicLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./MeetingSectionTextTopic'), require('./MeetingSectionTopicAttachment'), require('./MeetingSectionTopicCommentPaginationSlice'), require('./MeetingSectionTopicLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MeetingSectionTopicReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.MeetingSectionTextTopic, root.ForStractionServiceApi.MeetingSectionTopicAttachment, root.ForStractionServiceApi.MeetingSectionTopicCommentPaginationSlice, root.ForStractionServiceApi.MeetingSectionTopicLink);
  }
}(this, function(ApiClient, MeetingSectionTextTopic, MeetingSectionTopicAttachment, MeetingSectionTopicCommentPaginationSlice, MeetingSectionTopicLink) {
  'use strict';




  /**
   * The MeetingSectionTopicReport model module.
   * @module model/MeetingSectionTopicReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MeetingSectionTopicReport</code>.
   * @alias module:model/MeetingSectionTopicReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>MeetingSectionTopicReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MeetingSectionTopicReport} obj Optional instance to populate.
   * @return {module:model/MeetingSectionTopicReport} The populated <code>MeetingSectionTopicReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Attachments')) {
        obj['Attachments'] = ApiClient.convertToType(data['Attachments'], [MeetingSectionTopicAttachment]);
      }
      if (data.hasOwnProperty('Comments')) {
        obj['Comments'] = MeetingSectionTopicCommentPaginationSlice.constructFromObject(data['Comments']);
      }
      if (data.hasOwnProperty('TextTopic')) {
        obj['TextTopic'] = MeetingSectionTextTopic.constructFromObject(data['TextTopic']);
      }
      if (data.hasOwnProperty('TopicLink')) {
        obj['TopicLink'] = MeetingSectionTopicLink.constructFromObject(data['TopicLink']);
      }
      if (data.hasOwnProperty('HasContent')) {
        obj['HasContent'] = ApiClient.convertToType(data['HasContent'], 'Boolean');
      }
      if (data.hasOwnProperty('SectionID')) {
        obj['SectionID'] = ApiClient.convertToType(data['SectionID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentTypeID')) {
        obj['ContentTypeID'] = ApiClient.convertToType(data['ContentTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Notes')) {
        obj['Notes'] = ApiClient.convertToType(data['Notes'], 'String');
      }
      if (data.hasOwnProperty('BlobStorageURI')) {
        obj['BlobStorageURI'] = ApiClient.convertToType(data['BlobStorageURI'], 'String');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/MeetingSectionTopicAttachment>} Attachments
   */
  exports.prototype['Attachments'] = undefined;
  /**
   * @member {module:model/MeetingSectionTopicCommentPaginationSlice} Comments
   */
  exports.prototype['Comments'] = undefined;
  /**
   * @member {module:model/MeetingSectionTextTopic} TextTopic
   */
  exports.prototype['TextTopic'] = undefined;
  /**
   * @member {module:model/MeetingSectionTopicLink} TopicLink
   */
  exports.prototype['TopicLink'] = undefined;
  /**
   * @member {Boolean} HasContent
   * @default false
   */
  exports.prototype['HasContent'] = false;
  /**
   * @member {Integer} SectionID
   * @default 0
   */
  exports.prototype['SectionID'] = 0;
  /**
   * @member {Integer} ContentTypeID
   * @default 0
   */
  exports.prototype['ContentTypeID'] = 0;
  /**
   * @member {String} Notes
   * @default ''
   */
  exports.prototype['Notes'] = '';
  /**
   * @member {String} BlobStorageURI
   * @default ''
   */
  exports.prototype['BlobStorageURI'] = '';
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


